import { BackIcon } from '@braskai/icons';

import { SmallSizeLink } from './styled';

type TGoBackLinkProps = {
  text: string;
  onClick: () => void;
};

export const GoBackLink = ({ text, onClick }: TGoBackLinkProps) => {
  return (
    <SmallSizeLink onClick={onClick}>
      <BackIcon />
      <span>{text}</span>
    </SmallSizeLink>
  );
};
